// Fix asiago hockey events broken notizia-lnk-parent link and image
;(() => {
	if (!WC.idArticolo) {
		return
	}

	const element = document.querySelector('.notizia-lnk-parent')

	if (!element) {
		return
	}

	// Fix for AHL
	if (
		element.querySelector('img').getAttribute('src') === '' &&
		element.querySelector('h3').textContent.includes('Alps Hockey League')
	) {
		element.querySelector('img').src =
			'https://www.asiago.it/images/web/eventi_sport/alps_hockey_logo.png'

		const link = element.querySelector('a')
		switch (WC.idLingua) {
			case 2:
				link.setAttribute(
					'href',
					'https://www.asiago.it/en/pagine/default.aspx?menu=events&tip=27'
				)
				break
			case 3:
				link.setAttribute(
					'href',
					'https://www.asiago.it/de/pagine/default.aspx?menu=veranstaltungen&tip=27'
				)
				break
			default:
				link.setAttribute(
					'href',
					'https://www.asiago.it/it/pagine/default.aspx?menu=eventi&tip=27'
				)
		}
	}

	// Fix for ICE
	if (element.querySelector('h3').textContent.includes('ICE Hockey League')) {
		const link = element.querySelector('a')
		switch (WC.idLingua) {
			case 2:
				link.setAttribute(
					'href',
					'https://www.asiago.it/en/pagine/default.aspx?menu=events&tip=27#content-start'
				)
				break
			case 3:
				link.setAttribute(
					'href',
					'https://www.asiago.it/de/pagine/default.aspx?menu=veranstaltungen&tip=27#content-start'
				)
				break
			default:
				link.setAttribute(
					'href',
					'https://www.asiago.it/it/pagine/default.aspx?menu=eventi&tip=27#content-start'
				)
		}
	}
})()
